import React from 'react';
import { SectionHeader } from '../ui/SectionHeader';
import { Reveal } from '../ui/Reveal';
import { ServiceCard } from '../ui/ServiceCard';
import { services } from '../../data/services';
export function Services() {
  return <section id="servicios" className="bg-white py-20 lg:py-32" data-id="element-226" data-mp="djycpou9nzdh">
      <div className="mx-auto max-w-shell px-5 lg:px-10" data-id="element-227" data-mp="ibzv7si12mby">
        <SectionHeader eyebrow="Mis servicios" title={<>
              Soluciones de protección
              <br data-id="element-229" data-mp="s9e1x0e5fwr2" />
              <span className="text-teal" data-id="element-230" data-mp="s8upfz79q0kf">para diferentes etapas de tu vida.</span>
            </>} subtitle="Cada persona y cada familia tiene necesidades diferentes. Por eso exploramos diferentes alternativas." data-id="element-228" data-mp="idjapgvv0tco" />

        <div className="mt-14 grid gap-6 lg:mt-16 lg:grid-cols-3 lg:gap-7" data-id="element-231" data-mp="11883l56c7dbh">
          {services.map((s, i) => <Reveal key={s.id} delay={i * 0.08} className="h-full" data-id="element-232" data-mp="2y4yudjau9ejr" data-mpi={i}>
              <ServiceCard service={s} data-id="element-233" data-mp="3327bdgk93cjf" />
            </Reveal>)}
        </div>

        <p className="mx-auto mt-10 max-w-3xl text-center text-[12.5px] font-light leading-relaxed text-ink/45" data-id="element-234" data-mp="1orthj242ako8">
          Los beneficios, coberturas y productos disponibles están sujetos a elegibilidad,
          suscripción, disponibilidad y a los términos de cada póliza.
        </p>
      </div>
    </section>;
}